<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/community",
		    "name": "Community"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
      <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <ul class="breadcrumbsul">
                  <li><a href="#">Home</a></li>
                  <li>></li>
                  <li>Community</li>
              </ul>
          </div>
      </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                  <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
            </div>
        </div>
    </div>
</div>

<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit">
  <div class="container">
    <div class="row align-items-center">
      <div  class="col-lg-6 order-md-first">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/mobile-protectt/secure_mobile_devices_together.webp" class="og_image_url" alt="Secure Your Mobile Devices with our Mobile App Security Solution">
          </div>
        </div>
      </div>
      <div  class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <h2>Secure Mobile Devices Together</h2>
            </div>
            <p>The Protectt.ai community initiated online platform where clients, partners and professionals share the responsibility, experiences and expertise to secure the mobile devices.</p>
            <p>The Protectt.ai also connects through discussion forums, case studies and community blogs.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row align-items-center">
      <div  class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <span style="color: #da2b27;">AppProtectt – Anti Cloning</span>
            <div class="mt-2">
              <h2>Don’t let the fake affect your business</h2>
            </div>
            <p>Protectt.ai committed to contribute to the community and believe in inclusive innovation. We are
              offering our Anti-App cloning feature for free. Share your App, We will add protection elements that will
              make it irreversible by hackers and close the threshold of reverse engineering.</p>

            <p>Share your App to dev@protectt.ai</p>
          </div>
        </div>
      </div>
      <div  class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/mobile-protectt/don’t_let_the_fake.webp" alt="Get Anti-App cloning feature ">          
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<div class="section-service">
  <div class="container">
    <div  class="row">
      <div class="col-lg-12">
        <div class="section-title text-center">
          <h2>Blogs</h2>
        </div>
      </div>
    </div>
    <div class="row">

      <div  class="col-lg-4 col-md-6 col-12">
        <!-- Start Single Service -->
        <div class="service text-center service-2 padding-none cleaning-service mb-30">
          <div class="thumb">
            <a routerLink="/five-ways-to-enhance-your-android-phone-security">
              <img src="assets/images/blog/five-ways-to-enhance-your-android-phone-security.webp"
                alt="Android Phone Security">
            </a>
          </div>
          <div class="content">
            <h4><a routerLink="/five-ways-to-enhance-your-android-phone-security">5 Ways to Enhance your Android Phone
                Security</a></h4>
          </div>
        </div>
        <!-- End Single Service -->
      </div>

      <div  class="col-lg-4 col-md-6 col-12">
        <!-- Start Single Service -->
        <div class="service text-center service-2 padding-none cleaning-service  mb-30">
          <div class="thumb">
            <a routerLink="/smartphone-antivirus-need-of-the-hour">
              <img src="assets/images/blog/smartphone-antivirus-need-of-the-hour.webp" alt="Smartphone Antivirus">
            </a>
          </div>
          <div class="content">
            <h4><a routerLink="/smartphone-antivirus-need-of-the-hour">Smartphone Antivirus: Need of the Hour</a></h4>
          </div>
        </div>
        <!-- End Single Service -->
      </div>

      <div  class="col-lg-4 col-md-6 col-12">
        <!-- Start Single Service -->
        <div class="service text-center service-2 padding-none cleaning-service  mb-30">
          <div class="thumb">
            <a routerLink="/seven-must-have-apps-on-your-smartphone">
              <img src="assets/images/blog/seven-must-have-apps-on-your-smartphone.webp" alt="Smartphone Protection">
            </a>
          </div>
          <div class="content">
            <h4><a routerLink="/seven-must-have-apps-on-your-smartphone">Seven Must Have Apps on Your Smartphone</a>
            </h4>
          </div>
        </div>
        <!-- End Single Service -->
      </div>
    </div>
  </div>
</div>